import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import WhyAIAutomation from '../../Components/Automation/WhyAIAutomation'
import TechServicesSection from '../../Components/Automation/TechServicesSection'
import IndustriesWeServe from '../../Components/Automation/IndustriesWeServe'
import WhyPartnerWithUs from '../../Components/Automation/WhyPartnerWithUs'
import { ArrowRight, CheckCircle } from 'lucide-react'
import Banner from '../../Components/Banner'

import { Helmet } from 'react-helmet-async';
const featuresData = [
    {
        id: 1,
        title: "Data Strategy & Consulting",
        description:
            "At Mobikode, we help you build a strong, reliable data foundation that truly supports your business goals. We work with you to shape a clear data strategy and roadmap, understand your current maturity, and identify the right use cases with real ROI. Along with that, we ensure your data is well-governed, secure, and fully compliant so you can make confident, informed decisions every day.",
        image: "/assets/product/item6.png",
    },
    {
        id: 2,
        title: "Data Engineering & Platforms",
        description:
            "At Mobikode, we build modern data systems that turn complex data into simple insights using cloud platforms, real-time pipelines, and smart integrations to help businesses grow faster and make better decisions.",
        image: "/assets/product/item7.png",
    },
    {
        id: 3,
        title: "Business Intelligence & Reporting",
        description:
            "We help teams actually understand their data, not just look at it. Through simple, interactive dashboards, clear KPIs, and self-service BI, we make insights easy for everyone. Using tools like Power BI, Tableau, Looker, and Qlik, we turn financial and operational data into decisions people can act on.",
        image: "/assets/product/item8.png",
    },
    {
        id: 4,
        title: "Advanced Analytics & AI",
        description:
            "Shift your focus from understanding “what happened” to confidently knowing “what’s next.” At Mobikode, we use AI-powered analytics, machine learning, forecasting, and anomaly detection to turn complex data into simple, actionable insights helping operations and finance teams make faster, smarter decisions every day.",
        image: "/assets/product/item6.png",
    },
    {
        id: 5,
        title: "Industry & Domain Analytics",
        description:
            "At Mobikode, we build analytics that truly fit the way your business works. From BFSI and manufacturing to supply chain and HR, we turn your data into clear, practical insights that help you make better decisions, faster and with more confidence.",
        image: "/assets/product/item7.png",
    },
];

// --- DATA ---
const services = [
    {
        id: 1,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 2,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 3,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
    {
        id: 4,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 5,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 6,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
];

const toolsData = [
    {
        id: 1,
        title: "Cloud",
        desc: "AWS, Azure, Google Cloud",
    },
    {
        id: 2,
        title: "Data Platforms",
        desc: "Snowflake, BigQuery, Redshift, Synapse",
    },
    {
        id: 3,
        title: "BI & Visualization",
        desc: "Power BI, Tableau, Looker",
    },
    {
        id: 4,
        title: "AI & ML",
        desc: "Python, TensorFlow, PyTorch",
    },
    {
        id: 5,
        title: "Integration",
        desc: "Kafka, Airflow, dbt",
    },
];

const outcomesData = [
    {
        id: 1,
        text: "Faster, data-driven decision-making",
    },
    {
        id: 2,
        text: "Single source of truth across the enterprise",
    },
    {
        id: 3,
        text: "Predictive insights & automation",
    },
    {
        id: 4,
        text: "Improved efficiency, cost control & revenue growth",
    },
];

const whyMobikodePoints = [
    "We focus on business needs first, not just tools or technology",
    "Strong expertise in cloud solutions and enterprise data systems",
    "AI-driven, future-ready solutions built for real-world impact",
    "Flexible delivery models—project-based or fully managed support",
    "Proven experience working across multiple industries and challenges",
];

const approachData = [
    {
        id: 1,
        step: "01",
        title: "Understand the Business",
        desc: "KPIs, challenges, and measurable results",
    },
    {
        id: 2,
        step: "02",
        title: "Engineer the Data",
        desc: "Reliable, scalable, and secure pipelines",
    },
    {
        id: 3,
        step: "03",
        title: "Analyze & Model",
        desc: "Smart insights powered by AI",
    },
    {
        id: 4,
        step: "04",
        title: "Visualize & Enable",
        desc: "Smart dashboards, alerts, self-service tools",
    },
    {
        id: 5,
        step: "05",
        title: "Optimize Continuously",
        desc: "Governance, performance, and operational excellence",
    },
];

function DataAnalytics() {
    return (
        <div>
            <Helmet>
    <title>
        Data & Analytics Services | Data Engineering & AI Analytics | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode delivers data and analytics services that turn enterprise data into actionable insights through data strategy, data engineering, business intelligence, advanced analytics, AI, and industry-focused solutions."
    />

    <meta
        name="keywords"
        content="Data Analytics Services, Data Analytics Company, Data Engineering Services, Data Strategy Consulting, Business Intelligence Services, BI Reporting Services, Advanced Analytics Services, AI Analytics Services, Data Platform Services, Enterprise Data Solutions, Data Visualization Services, Predictive Analytics Services, Machine Learning Analytics, Cloud Data Solutions, Industry Analytics Services, Power BI Services, Tableau Services, Snowflake Data Solutions, BigQuery Services"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/data-analytics"
    />

    <meta
        property="og:title"
        content="Data & Analytics Services | Data Engineering & AI Analytics | Mobikode"
    />

    <meta
        property="og:description"
        content="Turn raw enterprise data into meaningful business intelligence with Mobikode's data and analytics services, covering data strategy, engineering, BI, AI-powered analytics, and industry-specific insights."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/data-analytics"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/product/bg2.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Data & Analytics Services | Data Engineering & AI Analytics | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's data analytics solutions for data strategy, modern data platforms, business intelligence, predictive analytics, AI, and industry-specific decision support."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/product/bg2.png"
    />
</Helmet>
            <AiHero title="Data & Analytics Services" text="Turn enterprise data into clear decisions, real insights, and meaningful impact." imgData="/assets/product/bg2.png" />
            <section className="w-full pt-16 lg:pt-[100px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[15px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row lg:items-center group lg:h-[507px]">
                        <div className="relative lg:absolute top-0 right-0 w-full lg:max-w-[656px] h-[250px] md:h-[350px] lg:h-full bg-gray-100 overflow-hidden">
                            <img
                                src="/assets/product/img2.png"
                                alt="ai automation"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>
                        <div className="relative z-20 w-[92%] sm:w-[85%] lg:w-full max-w-[719px] mx-auto lg:mx-0 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] px-[20px] py-[30px] lg:px-[60px] lg:py-[80px] -mt-[40px] lg:mt-0">
                            <h3 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora mb-[15px] lg:mb-[35px] leading-[1.3]">
                                From Raw Data to<br className="hidden lg:block" /> Real Intelligence.
                            </h3>
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">
                                At Mobikode, we help businesses make real sense of their data. Instead of just reports and dashboards, we turn data into clear, practical insights that support better decisions every day. With modern data platforms, analytics, and AI, we help teams work smarter, act faster, and achieve measurable results that truly matter for growth.

                            </p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>
                        </div>
                    </div>
                </div>
            </section>
            <WhyAIAutomation title="What We Do" fData={featuresData} />
            {/* <TechServicesSection title="Explore Our Services" sData={services} /> */}
            {/* <IndustriesWeServe /> */}
            <section className="w-full bg-[#FDFDFD] pb-16 lg:pb-24 relative overflow-hidden">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                    <div className="mb-[30px] lg:mb-[60px]">
                        <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] text-left">
                            Our Approach
                        </h2>
                        <p className="text-[#49577A] mt-2 text-left font-graphik font-[500] lg:text-[16px] text-[14px]">
                            Turning raw data into real business growth

                        </p>
                    </div>

                    {/* Grid for Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-[14px] lg:gap-[15px]">
                        {approachData.map((item) => (
                            <div
                                key={item.id}
                                className="relative lg:p-[30px] p-[16px] flex min-h-[220px] flex-col justify-between overflow-hidden group transition-all duration-300 border border-[#01386A45] hover:shadow-lg hover:-translate-y-1"
                            >
                                <div className="flex flex-col h-full w-full relative z-20">

                                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-4 leading-tight">
                                        {item.title}
                                    </h3>
                                    <div className="mt-auto relative grid grid-cols-1 grid-rows-1 items-center overflow-hidden">
                                        {/* <div className="col-start-1 row-start-1 transition-all duration-500 ease-in-out group-hover:-translate-x-[150%] group-hover:opacity-0">
                                            <div className="flex items-center gap-2 text-[#01386A] font-medium font-graphik cursor-pointer">
                                                <span>Read More</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-right"><path d="m9 18 6-6-6-6" /></svg>
                                            </div>
                                        </div> */}
                                        <p className="col-start-1 row-start-1 text-[#49577A] lg:text-[16px] text-[14px] font-graphik font-[500] leading-snug line-clamp-2 transition-all duration-500 ease-in-out translate-x-[150%] opacity-0 group-hover:translate-x-0 group-hover:opacity-100">
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                                <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A] z-10" />
                                <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 group-hover:w-full transition-all duration-500 ease-out z-10" />
                            </div>
                        ))}
                    </div>

                </div>
            </section>
            <section className="w-full bg-[#FDFDFD] pb-16 lg:pb-24 relative">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                    <div className="grid lg:grid-cols-2 grid-cols-1 items-start relative">

                        <div className="mb-[30px] lg:mb-[60px] lg:sticky lg:top-24">
                            <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] text-left">
                                Tools & Technologies
                            </h2>
                        </div>

                        <div className="grid grid-cols-1 gap-[12px]">
                            {toolsData.map((item) => (
                                <div
                                    key={item.id}
                                    className="relative border border-[#01386A45] bg-[#FFFFFF] lg:p-[40px] p-[20px] min-h-[150px] flex flex-col justify-center overflow-hidden group transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
                                >
                                    <h3 className="text-[#01386A] text-lg lg:text-[20px] font-[600] font-sora mb-2 leading-tight">
                                        {item.title}
                                    </h3>
                                    <p className="text-[#49577A] lg:text-[16px] text-[14px] font-graphik font-[500] leading-snug">
                                        {item.desc}
                                    </p>
                                    <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A] z-10" />
                                    <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 group-hover:w-full transition-all duration-500 ease-out z-10" />
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </section>
            <section className="w-full bg-white pb-10 lg:pb-16 relative overflow-hidden">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">

                    {/* --- Part 1: Outcomes We Deliver --- */}
                    <div className="mb-16 lg:mb-24">
                        <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] text-center mb-[40px] lg:mb-[60px]">
                            Outcomes We Deliver
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                            {outcomesData.map((item) => (
                                <div
                                    key={item.id}
                                    className="relative bg-[#F0F0F0] p-8 min-h-[180px] flex items-center justify-center text-center overflow-hidden group transition-all duration-300 hover:shadow-lg hover:-translate-y-1 rounded-sm border-t-4 border-transparent hover:border-[#F06115]"
                                >
                                    {/* Text Content */}
                                    <h3 className="text-[#01386A] lg:text-[20px] text-[16px] font-[600] font-sora leading-tight relative z-10">
                                        {item.text}
                                    </h3>

                                    {/* Decorative Background Corner */}
                                    <div className="absolute bottom-0 right-0 w-[120px] h-[100px] pointer-events-none transition-transform duration-500 group-hover:scale-110 opacity-30">
                                        <img src="/assets/career/wrap1.svg" alt="" className="w-full h-full object-contain object-bottom-right" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* --- Part 2: Why Mobikode? --- */}
                    <div className="bg-[#F9F9F9] p-8 lg:p-16 border border-gray-100">
                        <div className="max-w-[1000px] mx-auto">
                            <div className="text-left mb-10">
                                <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] mb-4">
                                    Why Mobikode?
                                </h2>
                                <p className="text-[#49577A] font-graphik font-[500] text-[14px] lg:text-[16px]">
                                    We don’t just give you tools, we help you understand your business better with analytics that grow and adapt as you do.

                                </p>
                            </div>

                            {/* Checkpoints Grid */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-12">
                                {whyMobikodePoints.map((point, index) => (
                                    <div key={index} className="flex items-start gap-3 group">
                                        <div className="mt-1">
                                            <CheckCircle size={20} className="text-[#F06115] fill-[#F06115]/10" />
                                        </div>
                                        <p className="text-[#01386A] font-graphik lg:text-[16px] text-[14px] font-[500] group-hover:text-[#F06115] transition-colors duration-300">
                                            {point}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            {/* <section className="relative w-full h-[400px] lg:h-[507px] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/career/img12.png"
                        alt="Agentic AI Background"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/10"></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] lg:px-[80px] h-full flex items-center lg:items-center ">
                    <div className="bg-white p-8 lg:p-12 max-w-[588px] shadow-2xl rounded-sm">

                        <h2 className="text-[#01386A] text-[30px] lg:text-[40px] font-[600] font-sora leading-tight mb-6">
                            Agentic AI Services for Enterprises
                        </h2>
                        <p className="text-[#49577A] text-[16px] leading-[24px] font-graphik mb-8">
                           Helping businesses grow smarter with AI that works on its own, improves efficiency, and sparks innovation.

                        </p>
                        <a href="/contact" className="inline-flex items-center gap-2 text-[#01386A] underline font-graphik font-semibold text-lg hover:gap-3 transition-all duration-300 group">
                            Contact Now
                            <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
                        </a>

                    </div>

                </div>

            </section> */}
            <Banner title="Data & Analytics Services" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
        </div>
    )
}

export default DataAnalytics
